export const useDotsUniforms = async () => {
  const uTime = useUniformTime()
  const uResolution = useUniformResolution()
  const uMouse = useUniformMouse()

  const cameraUniforms = useUniformsCamera()

  const tFlowMap = inject("tFlowMap")

  const tGradient = await useTexture(["/images/gradient@lg.webp"])
  const tNoise = await useTexture(["/images/noise_green@lg.webp"])
  tNoise.wrapS = tNoise.wrapT = RepeatWrapping

  return {
    uTime,
    uResolution,
    uMouse,
    tGradient: { value: tGradient },
    tNoise: { value: tNoise },
    tFlowMap,
    ...cameraUniforms,
  }
}
